// Page404 Componenet

import React, { Component } from 'react'

import IntlMessage from '../../common/intl/intl_message.jsx'

class PageBlock extends Component {
  render () {
    return (
      <div className='page-block'>
        <div className='container'>
          <div className='inner'>
            <div className='warningimg'>
              <img
                src='/images/common/warning_block.png'
                className='inline-image'
              />
            </div>
            <div className='typo'>
              <h1 className='title'>
                <IntlMessage ident='common.block.title' />
              </h1>
              <div className='content'>
                <p>
                  <IntlMessage ident='common.block.info' />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PageBlock
